import { useState } from "react";
import { api } from "../lib/api";
import { useContent } from "../lib/content";
import { toast } from "sonner";

export default function TestimonialForm() {
  const { t } = useContent();
  const [form, setForm] = useState({ name: "", message: "", rating: 0 });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.message.trim().length < 10) {
      toast.error("Por favor escribe al menos unas líneas (mínimo 10 caracteres).");
      return;
    }
    setLoading(true);
    try {
      await api.post("/testimonials", {
        name: form.name.trim() || null,
        message: form.message.trim(),
        rating: form.rating || null,
      });
      setSent(true);
      toast.success(t("testimonial_form_success"));
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No se pudo enviar el testimonio");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div data-testid="testimonial-sent" className="card text-center mt-10">
        <p className="text-[#C9A25E] text-4xl mb-3">✦</p>
        <p className="font-display text-2xl text-white">{t("testimonial_form_success")}</p>
      </div>
    );
  }

  return (
    <div className="pt-16" data-testid="testimonial-form-section">
      <p className="overline mb-3">{t("testimonial_form_overline")}</p>
      <h2 className="font-display text-3xl sm:text-4xl text-white font-light tracking-tight mb-3">
        {t("testimonial_form_title")}
      </h2>
      <p className="text-zinc-400 mb-8 leading-relaxed text-sm">{t("testimonial_form_subtitle")}</p>

      <form onSubmit={submit} data-testid="testimonial-form" className="space-y-5">
        <div>
          <label className="field-label">{t("testimonial_form_label_name")}</label>
          <input
            data-testid="testimonial-name"
            className="input-field"
            placeholder={t("testimonial_form_name_placeholder")}
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />
        </div>
        <div>
          <label className="field-label">{t("testimonial_form_label_rating")}</label>
          <div className="flex gap-2 mt-1" data-testid="testimonial-rating">
            {[1, 2, 3, 4, 5].map((n) => (
              <button
                key={n}
                type="button"
                data-testid={`testimonial-rating-${n}`}
                onClick={() => setForm({ ...form, rating: form.rating === n ? 0 : n })}
                className={`text-2xl transition ${
                  n <= form.rating ? "text-[#C9A25E]" : "text-zinc-700 hover:text-zinc-500"
                }`}
                aria-label={`${n} estrellas`}
              >
                ✦
              </button>
            ))}
          </div>
        </div>
        <div>
          <label className="field-label">{t("testimonial_form_label_message")}</label>
          <textarea
            required
            rows={5}
            data-testid="testimonial-message"
            className="input-field"
            placeholder={t("testimonial_form_message_placeholder")}
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
          />
        </div>
        <button type="submit" disabled={loading} data-testid="testimonial-submit" className="btn-lilac">
          {loading ? "Enviando…" : t("testimonial_form_submit")}
        </button>
        <p className="text-xs text-zinc-600">{t("testimonial_form_note")}</p>
      </form>
    </div>
  );
}
